import {
  Bell,
  FileText,
  Images,
  ClipboardList,
  LayoutDashboard,
  Settings,
  ShoppingBag,
  Tags,
  UsersRound,
} from 'lucide-react'
import type { Icon } from '../types/ui'

export type NavItem = {
  to: string
  label: string
  icon: Icon
}

export const navItems: NavItem[] = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/products', label: 'Products', icon: ShoppingBag },
  { to: '/gallery', label: 'Gallery', icon: Images },
  { to: '/cms', label: 'CMS', icon: FileText },
  { to: '/offers', label: 'Offers', icon: Tags },
  { to: '/orders', label: 'Orders', icon: ClipboardList },
  { to: '/customers', label: 'Customers', icon: UsersRound },
  { to: '/notifications', label: 'Notifications', icon: Bell },
  { to: '/settings', label: 'Profile Settings', icon: Settings },
]
